import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ZeroCostPaymentPanelProps {
  isProcessing: boolean;
  isVoucherApplied: boolean;
  isDiscountApplied: boolean;
  isAdminDiscountApplied: boolean;
  onCompleteRegistration: () => void;
}

export function ZeroCostPaymentPanel({
  isProcessing,
  isVoucherApplied,
  isDiscountApplied,
  isAdminDiscountApplied,
  onCompleteRegistration,
}: ZeroCostPaymentPanelProps) {
  const reason = isVoucherApplied
    ? "Your voucher covers the registration cost."
    : isDiscountApplied
      ? "Your discount code covers the registration cost."
      : isAdminDiscountApplied
        ? "The admin discount covers the registration cost."
        : "This registration is free of charge.";

  return (
    <div>
      <p className="text-sm text-muted-foreground mb-4">
        {reason} No payment required.
      </p>
      <Button
        className="w-full"
        disabled={isProcessing}
        onClick={onCompleteRegistration}
      >
        {isProcessing ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin mr-2" />
            Processing...
          </>
        ) : (
          "Complete Registration"
        )}
      </Button>
    </div>
  );
}

export default ZeroCostPaymentPanel;
